module.exports = __webpack_public_path__ + "img/screen02.edbb9230.jpg";